import { render, staticRenderFns } from "./indentification_protocol.vue?vue&type=template&id=7a1a12b3&scoped=true"
import script from "./indentification_protocol.vue?vue&type=script&lang=js"
export * from "./indentification_protocol.vue?vue&type=script&lang=js"
import style0 from "./indentification_protocol.vue?vue&type=style&index=0&id=7a1a12b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1a12b3",
  null
  
)

export default component.exports